"use client";

import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";

import "./styles.css";

import { FreeMode, Navigation, Thumbs } from "swiper";
import Image from "next/image";

export function MediaCarousel({ images = [] }: { images?: any[] }) {
  // Note: Could not find exported Swiper type
  const [thumbsSwiper, setThumbsSwiper] = useState<any>(null);

  return (
    <div className="mb-8">
      <Swiper
        style={{
          // @ts-ignore
          "--swiper-navigation-color": "var(--color-blue-500)",
          "--swiper-pagination-color": "var(--color-blue-500)",
        }}
        spaceBetween={10}
        navigation={true}
        thumbs={{
          swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null,
        }}
        modules={[FreeMode, Navigation, Thumbs]}
        className="mySwiper2"
      >
        {images.map(({ image, original }, index) => (
          <SwiperSlide key={index}>
            <Image
              {...image}
              alt={original.alt || ""}
              // title="images from ..."
              // blurDataURL={base64}
              placeholder="empty"
              unoptimized
              priority={index === 0}
            />
          </SwiperSlide>
        ))}
      </Swiper>
      <Swiper
        onSwiper={setThumbsSwiper}
        spaceBetween={10}
        slidesPerView={5}
        freeMode={true}
        watchSlidesProgress={true}
        modules={[FreeMode, Navigation, Thumbs]}
        className="mySwiper"
      >
        {images.map(({ image, original, base64 }, index) => (
          <SwiperSlide key={index}>
            <Image
              {...image}
              alt={original.alt || ""}
              blurDataURL={base64}
              placeholder="blur"
              unoptimized
              priority
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
